@if (isVisible()) {
  <!-- Jauge de complétude du profil -->
  <div
    class="bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 p-5 shadow-xs space-y-3 relative"
  >
    <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
      <div class="flex items-center gap-3.5 min-w-0 pr-8 sm:pr-0">
        <div
          class="w-10 h-10 rounded-xl flex items-center justify-center font-black text-sm shrink-0"
          [class.bg-success-2]="profileCompletion() === 100"
          [class.text-success-11]="profileCompletion() === 100"
          [class.bg-primary-2]="profileCompletion() < 100"
          [class.text-primary-11]="profileCompletion() < 100"
        >
          @if (profileCompletion() === 100) {
            <mat-icon class="text-success-11">check</mat-icon>
          } @else {
            {{ profileCompletion() }}%
          }
        </div>
        <div class="min-w-0">
          <h3 class="text-base font-bold text-neutral-12">
            @if (profileCompletion() === 100) {
              Profil 100% complété !
            } @else {
              Complétude de votre profil
            }
          </h3>
          <p class="text-xs text-neutral-11 whitespace-normal break-words">
            @if (profileCompletion() === 100) {
              Félicitations ! Votre profil est complet et optimisé pour recevoir des mandats.
            } @else {
              Un profil détaillé inspire davantage confiance aux propriétaires vendeurs.
            }
          </p>
        </div>
      </div>

      @if (profileCompletion() < 100) {
        <span
          class="text-xs font-semibold px-3 py-1 bg-neutral-2 dark:bg-neutral-3 text-neutral-11 dark:text-neutral-12 border border-neutral-3 dark:border-neutral-4 rounded-full text-center whitespace-normal self-start sm:self-auto"
        >
          {{ completionTip() }}
        </span>
      } @else {
        <!-- Croix pour fermer / masquer l'information de complétude -->
        <button
          type="button"
          mat-icon-button
          class="!absolute top-3 right-3 text-neutral-9 hover:text-neutral-12"
          (click)="onDismiss()"
          aria-label="Fermer"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- Barre de progression -->
    <div
      class="w-full bg-neutral-2 dark:bg-neutral-3 h-2 rounded-full overflow-hidden border border-neutral-3 dark:border-neutral-4"
    >
      <div
        class="h-full rounded-full transition-all duration-500 ease-out"
        [class.bg-success-9]="profileCompletion() === 100"
        [class.bg-primary-9]="profileCompletion() < 100"
        [style.width.%]="profileCompletion()"
      ></div>
    </div>
  </div>

  @if (showDivider()) {
    <mat-divider class="my-4"></mat-divider>
  }
}
